import { useState } from "react";
import axios from "axios";
import { Button } from "@/components/ui/button";
import { Mail, X, Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function VerifyEmailModal({ onClose }) {
  const [resending, setResending] = useState(false);
  const [resent, setResent] = useState(false);

  const handleResend = async () => {
    setResending(true);
    try {
      await axios.post(`${API}/auth/resend-verification`, {}, { withCredentials: true });
      setResent(true);
    } catch {
      // Fail silently
    }
    setResending(false);
  };

  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl max-w-md w-full p-6 relative">
        <button onClick={onClose} className="absolute top-4 right-4 text-slate-400 hover:text-slate-600">
          <X size={18} />
        </button>
        <div className="w-14 h-14 rounded-2xl bg-orange-50 flex items-center justify-center mx-auto mb-4">
          <Mail size={24} className="text-orange-500" />
        </div>
        <h3 className="text-lg font-bold text-center mb-2" style={{ fontFamily: "Outfit, sans-serif", color: "#0F172A" }}>
          Verify Your Email
        </h3>
        <p className="text-sm text-slate-500 text-center mb-6">
          You need to verify your email address before upgrading your plan. Check your inbox for a verification link.
        </p>
        {resent ? (
          <div className="p-3 rounded-xl bg-emerald-50 border border-emerald-200 text-sm text-emerald-700 text-center mb-4">
            Verification email sent! Check your inbox.
          </div>
        ) : (
          <Button
            onClick={handleResend}
            disabled={resending}
            className="w-full rounded-xl h-11 text-white border-0 mb-3"
            style={{ background: "linear-gradient(135deg, #F97316 0%, #D946EF 100%)" }}>
            {resending ? (
              <span className="flex items-center gap-2"><Loader2 size={16} className="animate-spin" /> Sending...</span>
            ) : (
              <span className="flex items-center gap-2"><Mail size={16} /> Resend Verification Email</span>
            )}
          </Button>
        )}
        <p className="text-xs text-slate-400 text-center">
          Didn't receive it? Check your spam folder or try resending.
        </p>
      </div>
    </div>
  );
}
